
import {useSelector} from 'react-redux';

const UserID = ()=>{

      const {userInfo} = useSelector(state=>state.userLogin);
      const {token} = useSelector(state=>state.userLogin);

    //   console.log(userInfo);
        
      return (
            <>
              {
                    userInfo?.PID && (<span
                                        className='text-danger mr-2'
                                      >ID:{userInfo.PID} No. {token}</span>)
              }
            </>
      );

};

export default UserID;